module.exports = __webpack_public_path__ + "static/media/manage_employees.69ff24da.svg";